import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function coinbaseWallet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$darkMode = _ref.darkMode,
    darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode;
  return function () {
    return {
      label: 'Coinbase Wallet',
      getIcon: function () {
        var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import('./icon.js');
              case 2:
                return _context.abrupt("return", _context.sent.default);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getIcon() {
          return _getIcon.apply(this, arguments);
        }
        return getIcon;
      }(),
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
          var chains, appMetadata, _chains, chain, _ref3, name, icon, _yield$import, CoinbaseWalletSDK, CoinbaseWalletSDKConstructor, base64, appLogoUrl, instance, coinbaseWalletProvider, on;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                chains = _ref2.chains, appMetadata = _ref2.appMetadata;
                _chains = _slicedToArray(chains, 1), chain = _chains[0];
                _ref3 = appMetadata || {}, name = _ref3.name, icon = _ref3.icon; // according to https://github.com/wagmi-dev/wagmi/issues/383
                // @coinbase/wallet-sdk export double default fields
                // so we need to detect it to get the real constructor
                _context2.next = 5;
                return import('@coinbase/wallet-sdk');
              case 5:
                _yield$import = _context2.sent;
                CoinbaseWalletSDK = _yield$import.default;
                CoinbaseWalletSDKConstructor = CoinbaseWalletSDK.default ? CoinbaseWalletSDK.default : CoinbaseWalletSDK;
                base64 = window.btoa(icon || '');
                appLogoUrl = "data:image/svg+xml;base64,".concat(base64);
                instance = new CoinbaseWalletSDKConstructor({
                  appName: name || '',
                  appLogoUrl: appLogoUrl,
                  darkMode: darkMode
                });
                coinbaseWalletProvider = instance.makeWeb3Provider(chain.rpcUrl, parseInt(chain.id)); // patch the chainChanged event
                on = coinbaseWalletProvider.on.bind(coinbaseWalletProvider);
                coinbaseWalletProvider.on = function (event, listener) {
                  on(event, function (val) {
                    if (event === 'chainChanged') {
                      listener("0x".concat(val.toString(16)));
                      return;
                    }
                    listener(val);
                  });
                  return coinbaseWalletProvider;
                };
                return _context2.abrupt("return", {
                  provider: coinbaseWalletProvider,
                  instance: instance
                });
              case 15:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }
        return getInterface;
      }()
    };
  };
}
export default coinbaseWallet;